"use client"
import { useState, useRef } from "react"
import { cn } from "../../utils/cn"

export const HoverBorderGradient = ({
  children,
  containerClassName,
  className,
  as: Component = "div",
  from = "#3b82f6",
  to = "#4f46e5",
  fromOpacity = 0.5,
  toOpacity = 0.8,
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const ref = useRef(null)

  const handleMouseMove = (e) => {
    if (!ref.current) return
    const rect = ref.current.getBoundingClientRect()
    setPosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    })
  }

  return (
    <Component
      ref={ref}
      className={cn("relative p-[1px] group", containerClassName)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseMove={handleMouseMove}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <div
        className="absolute inset-0 rounded-[inherit] opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        style={{
          background: `radial-gradient(circle at ${position.x}px ${position.y}px, ${from}${Math.round(
            fromOpacity * 255,
          ).toString(16)} 0%, ${to}${Math.round(toOpacity * 255).toString(16)} 50%, transparent 70%)`,
        }}
      />
      <div className={cn("relative", className)}>{children}</div>
    </Component>
  )
}
